module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bc52204!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 1025
// module chunks = 40